<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem : {{ modelData.name }} <!-- / Khóa : {{ configData.course.name | courseName }} / {{ configData.chapter.name }} --></h2>
        <el-button @click="backModel" size="small" class="btn-back">
          Trờ về <!-- : {{ configData.course.name | courseName }} / {{ configData.chapter.name }} -->
        </el-button>
      </div>
    </el-row>
    <question-index></question-index>
    <el-row :gutter="10">
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="left" :model="modelData" ref="createModel" @submit.native.prevent label-width="180px">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item prop="type_time_txt" label="Kiểu đề thi" class="form-item">
                  <span>{{ modelData.type_time_txt }}</span>
                </el-form-item>
                <el-form-item prop="time" label="Thời gian" class="form-item">
                  <span>{{ modelData.time }} phút</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="type_question_txt" label="Loại đề thi : " class="form-item">
                  <span>{{ modelData.type_question_txt }}</span>
                </el-form-item>
                <el-form-item prop="score_success" label="Điểm đạt" class="form-item">
                  <span>{{ modelData.score_success }} điểm</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                disabled
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import QuestionIndex from '@/components/questions/Index'
export default {
  name: 'TestKitShow',
  metaInfo () {
    return {
      title: 'Đề thi'
    }
  },
  components: {
    QuestionIndex
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        chapter_id: '',
        time_video: '',
        link_video: '',
        lesson_content: '',
        lesson_document: '',
        lesson_part: false,
        status: true
      },
      configData: {
        course: {
          id: 0,
          name: 'Tên khóa này'
        },
        chapter: {
          id: 0,
          name: 'Tên chương này'
        }
      }
    }
  },
  mounted () {
    this.fetchModel()
    this.configDataAndBreadcrumb()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình dữ liệu về khóa học, bài, cấu hình Breadcrumb
    configDataAndBreadcrumb () {
      this.modelData.chapter_id = this.$route.params.chapter_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.course = response.data
            this.fetchChapter()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchChapter () {
      axios.get('chapters/' + this.$route.params.chapter_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.chapter = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-show', course_id: this.$route.params.course_id, text: this.configData.course.name },
        { name: 'chapters-show', course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id, text: this.configData.chapter.name },
        { name: 'chapters-index', text: 'Xem chi tiết đề thi' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'chapters-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('test-kits/' + this.$route.params.test_kit_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/test-results/Show.vue